import { deleteApi, getApi, patchApi, postApi } from "./general.service";

// Nuevo motor de mensajería (core/messaging en boost-api-v3). El base URL ya incluye /v3.

// Previsualiza una audiencia a partir de una SegmentDefinition (conteo + muestra).
export const previewSegment = async (definition) => {
  return postApi("/messaging/segments/preview", definition);
};

export const listCampaigns = async () => {
  return getApi("/messaging/campaigns");
};

export const getCampaign = async (id) => {
  return getApi(`/messaging/campaigns/${id}`);
};

export const createCampaign = async (data) => {
  return postApi("/messaging/campaigns", data);
};

export const updateCampaign = async (id, data) => {
  return patchApi(`/messaging/campaigns/${id}`, data);
};

export const deleteCampaign = async (id) => {
  return deleteApi(`/messaging/campaigns/${id}`);
};

// Envío de prueba a un usuario concreto (normalmente el admin logueado).
export const testCampaign = async (id, userId) => {
  return postApi(`/messaging/campaigns/${id}/test`, { userId });
};

export const previewCampaignAudience = async (id) => {
  return postApi(`/messaging/campaigns/${id}/preview`, {});
};

export const dispatchCampaign = async (id) => {
  return postApi(`/messaging/campaigns/${id}/dispatch`, {});
};

// Anuncio rápido: crea la campaña y la despacha en un solo paso.
export const quickCampaign = async (data) => {
  return postApi("/messaging/campaigns/quick", data);
};

// Sube una imagen para campañas (drag & drop del editor). Devuelve { url, key }.
export const uploadCampaignAsset = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const token = JSON.parse(localStorage?.getItem("user") || "{}")?.token;
  const response = await fetch(`${process.env.REACT_APP_API_URL}/messaging/assets`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  if (!response.ok) throw new Error(response.statusText);
  return response.json();
};

// ── Seguimiento y control del envío ──────────────────────────────────────────

// Progreso real desde los buckets: total, por canal y por tanda.
export const getCampaignProgress = async (id) => {
  return getApi(`/messaging/campaigns/${id}/progress`);
};

// Destinatarios en un estado concreto (failed/sent/skipped/pending), paginado.
export const getCampaignRecipients = async (id, { state = "failed", channel, skip = 0, limit = 100 } = {}) => {
  const params = new URLSearchParams({ state, skip, limit });
  if (channel) params.set("channel", channel);
  return getApi(`/messaging/campaigns/${id}/recipients?${params.toString()}`);
};

// Lanza la siguiente tanda a mano (ademas del cron diario).
export const dispatchNextBatch = async (id) => {
  return postApi(`/messaging/campaigns/${id}/batch`, {});
};

export const pauseCampaign = async (id) => {
  return postApi(`/messaging/campaigns/${id}/pause`, {});
};

export const resumeCampaign = async (id) => {
  return postApi(`/messaging/campaigns/${id}/resume`, {});
};

// Re-encola SOLO los destinatarios fallidos.
export const retryCampaignFailures = async (id) => {
  return postApi(`/messaging/campaigns/${id}/retry`, {});
};

// HTML REAL del correo (el mismo render que el envío) para la campaña tal cual está
// en el editor, sin guardar. Devuelve { subject, html }.
export const renderCampaignMail = async (campaign, lang) => {
  return postApi("/messaging/campaigns/render-mail", { campaign, lang });
};
